import { useCallback, memo } from "react";
import { Fade, Stack } from "@mui/material";
import { MentionFilter } from "../../filters/MentionFilter/MentionFilter";
import { EXPORT_INCLUSION_TYPES } from "../types";

const MemoizedMentionFilter = memo(
  ({
    selectedMentionIds,
    onMentionsSelect,
  }: {
    selectedMentionIds: number[];
    onMentionsSelect: (ids: number[]) => void;
  }) => (
    <Fade in={true} timeout={300}>
      <Stack sx={{ mx: 4 }}>
        <MentionFilter
          selectedMentionIds={selectedMentionIds}
          onMentionsSelect={onMentionsSelect}
        />
      </Stack>
    </Fade>
  )
);

MemoizedMentionFilter.displayName = "MemoizedMentionFilter";

export const useMentionFilterRenderer = (
  inclusion: EXPORT_INCLUSION_TYPES,
  selectedMentionIds: number[],
  onMentionsSelect: (ids: number[]) => void
) => {
  return useCallback(
    (optionValue: string) => {
      if (
        optionValue === EXPORT_INCLUSION_TYPES.SELECTED &&
        inclusion === EXPORT_INCLUSION_TYPES.SELECTED
      ) {
        return (
          <MemoizedMentionFilter
            selectedMentionIds={selectedMentionIds}
            onMentionsSelect={onMentionsSelect}
          />
        );
      }
      return null;
    },
    [inclusion, selectedMentionIds, onMentionsSelect]
  );
};
